import { DataTable } from '@peritasai/ui-components';
import type { GridColDef, GridPaginationModel } from '@mui/x-data-grid-premium';
import type { CaseTypeEntity } from '@peritasai/repository';
import { useTranslation } from 'react-i18next';
import { renderTableCell } from '../shared/renderTableCell';

const getColumns = (
  t: (key: string) => string
): GridColDef<CaseTypeEntity>[] => [
  {
    field: 'displayName',
    headerName: t('pages.entityManagement.caseTypesTable.columnName'),
    flex: 1,
    renderCell: (params) => renderTableCell(params.value, true),
  },
  {
    field: 'caseTypeId',
    headerName: t('pages.entityManagement.caseTypesTable.columnId'),
    flex: 1,
    renderCell: (params) => renderTableCell(params.value),
  },
  {
    field: 'description',
    headerName: t('pages.entityManagement.caseTypesTable.columnDescription'),
    flex: 1,
    renderCell: (params) => renderTableCell(params.value),
  },
  {
    field: 'specialty',
    headerName: t('pages.entityManagement.caseTypesTable.columnSpecialty'),
    flex: 1,
    renderCell: (params) => renderTableCell(params.value),
  },
  {
    field: 'procedureCode',
    headerName: t('pages.entityManagement.caseTypesTable.columnProcedureCode'),
    flex: 1,
    headerClassName: 'last-column-header',
    renderCell: (params) => renderTableCell(params.value),
  },
];

interface CaseTypesTableProps {
  rows: CaseTypeEntity[];
  rowCount: number;
  isLoading: boolean;
  hasSearch: boolean;
  paginationModel: GridPaginationModel;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  onRowClick: (row: CaseTypeEntity) => void;
}

export const CaseTypesTable = ({
  rows,
  rowCount,
  isLoading,
  hasSearch,
  paginationModel,
  onPaginationModelChange,
  onRowClick,
}: CaseTypesTableProps) => {
  const { t } = useTranslation(['periverse']);
  const columns = getColumns(t);

  return (
    <DataTable
      rows={rows}
      columns={columns}
      getRowId={(row) => row.id}

      rowCount={rowCount}
      isLoading={isLoading}
      hasSearch={hasSearch}
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      onRowClick={onRowClick}
      searchEmptyTitle={t('pages.entityManagement.table.searchEmptyTitle')}
      searchEmptyMessage={t('pages.entityManagement.table.searchEmptyMessage')}
      emptyMessage={t('pages.entityManagement.table.noRows', {
        entityName: t('pages.entityManagement.items.caseTypes'),
      })}
      skeletonColumnCount={5}
    />
  );
};
